import { Eye } from 'lucide-react';
import { useResellerScope, useStopImpersonation } from '../api/resellers.js';

/**
 * Persistent banner shown while an admin is impersonating a reseller's scoped
 * view (G20). A reseller login never sees it (they are natively the reseller);
 * it appears only when `impersonating` is true, with a one-click exit.
 */
export function ImpersonationBanner() {
  const scope = useResellerScope();
  const stop = useStopImpersonation();

  if (!scope.data?.impersonating) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-amber-300 bg-amber-100 px-4 py-2.5 text-sm text-amber-900 sm:px-6 lg:px-8 dark:border-amber-700/60 dark:bg-amber-950/60 dark:text-amber-200">
      <span className="flex items-center gap-2">
        <Eye className="size-4 shrink-0" aria-hidden />
        Viewing the panel as reseller <strong>{scope.data.resellerName}</strong> — you see only their
        clients, plans and subscriptions.
      </span>
      <button
        onClick={() => stop.mutate()}
        disabled={stop.isPending}
        className="rounded-md bg-amber-800 px-3 py-1 text-xs font-semibold text-white hover:bg-amber-900 disabled:opacity-60 dark:bg-amber-600 dark:hover:bg-amber-500"
      >
        {stop.isPending ? 'Leaving…' : 'Stop impersonating'}
      </button>
    </div>
  );
}
